import React from "react";
import { Button, Container } from "react-bootstrap";
import "./Teams.css";
import TableComponent from "../Common/TableComponent";
import TopHeader from "../Common/TopHeader";
import { GetApiMethod } from "../../core/services/apiService";
import AppLoader from "../AppLoader/AppLoader";
import TooltipPositioned from "../Tooltip/TooltipPositioned";
import { useAppSelector } from "../../core/redux/hooks";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAppDispatch } from "../../core/redux/hooks";
import { DtoAgentStatus, DtoTeamsAgentDetails } from "../../core/dto/dashboard.dto";

import { setAgentToAgentOutBoundVoiceCallAgentDetails, setOutBoundCallLocationDetails, setOutBoundCallConnection } from "../../core/redux/notificationsSlice";
import { GetTenantId, loggerHelper } from "../../core/services/sharedService";

const Teams = React.memo<{ addAgentModel?: boolean, addAgentModelCallBackFunction?: Function }>(({ addAgentModel, addAgentModelCallBackFunction }) => {
    let authState = useAppSelector((state) => state.auth);
    let LoginUserDetails = useAppSelector((state) => state.auth.users);

    const [agentStatusListInfo, setAgentStatusListInfo] = React.useState<{ [index: string]: string }>({});
    const [showLoader, setShowLoader] = React.useState(true);
    const [data, setData] = React.useState<any>([]);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const tenantID = GetTenantId();

    React.useEffect(() => {
        setShowLoader(true);
        const getall_agents_url = "tenant/agent/list-all-agents";
        GetApiMethod(getall_agents_url).then((res) => {
            setShowLoader(false);
            setData(res.data.data);
        });
    }, []);

    React.useEffect(() => {
        const agentStatusList: { [index: string]: string } = {};
        if (authState.allAgentStatusDetails && authState.allAgentStatusDetails.length) {
            authState.allAgentStatusDetails.forEach((statusDetails: DtoAgentStatus) => {
                if (tenantID === statusDetails.tenantID)
                    agentStatusList[statusDetails.email] = statusDetails.status;
            });
            setAgentStatusListInfo({ ...agentStatusList });
        }
    }, [authState.allAgentStatusDetails])

    const agentToAgentVoiceCall = React.useCallback((agentDetails: DtoTeamsAgentDetails) => {
        dispatch(setOutBoundCallConnection(undefined));
        dispatch(setOutBoundCallLocationDetails(undefined))
        dispatch(setAgentToAgentOutBoundVoiceCallAgentDetails(agentDetails));
        loggerHelper("clicked on agentToAgentVoiceCall");
        setTimeout(() => {
            navigate("/dashboard");
        }, 500);
    }, [dispatch, navigate])

    let columns: any = [
        {
            name: "Name",
            selector: (row: any) => row.name,
            sortable: true,
        },
        {
            name: "Email",
            selector: (row: any) => row.email,
            sortable: true,
        },
        {
            name: "Primary Location",
            selector: (row: any) => (
                <div>
                    {('primary_location' in row && row.primary_location.length > 0) ?
                        TooltipPositioned({
                            placement: "top",
                            item: getLocationsAsCSV(row.primary_location),
                        }) : "-"}
                </div>
            ),
        },
        {
            name: "Secondary Location",
            selector: (row: any) => (
                <div>
                    {('secondary_location' in row && row.secondary_location.length > 0) ?
                        TooltipPositioned({
                            placement: "top",
                            item: getLocationsAsCSV(row.secondary_location),
                        }) : "-"}
                </div>
            ),
        },
        {
            name: "Status",
            cell: (row: any) => (
                <div className="agentStatus text-capitalize">
                    <span
                        className={
                            agentStatusListInfo[row.email] ?
                                agentStatusListInfo[row.email].toLowerCase() :
                                'offline'
                        }
                    ></span>{" "}
                    {agentStatusListInfo[row.email] ? agentStatusListInfo[row.email] : 'Offline'}
                </div>
            ),
        },
        {
            name: "Voice Call",
            cell: (row: any) => (
                <Button
                    size="sm"
                    disabled={
                        agentStatusListInfo[row.email] &&
                            ["online", "collections"].includes(agentStatusListInfo[row.email].toLowerCase()) &&
                            LoginUserDetails.email !== row.email &&
                            agentStatusListInfo[LoginUserDetails.email] &&
                            ["online", "collections"].includes(agentStatusListInfo[LoginUserDetails.email].toLowerCase())
                            ? false
                            : true
                    }
                    className="ml-1"
                    onClick={() => {
                        agentToAgentVoiceCall(row);
                    }}
                    variant="success"
                >
                    <i className="bi bi-telephone-fill"></i>
                </Button>
            ),
        },
    ];

    if (addAgentModel && addAgentModelCallBackFunction) {
        let addAgentColumn = [
            {
                name: "Name",
                selector: (row: any) => row.name,
                sortable: true,
            },
            {
                name: "Email",
                selector: (row: any) => row.email,
                sortable: true,
            },
            {
                name: "Status",
                cell: (row: any) => (
                    <div className="agentStatus text-capitalize">
                        <span
                            className={
                                agentStatusListInfo[row.email] ?
                                    agentStatusListInfo[row.email].toLowerCase() :
                                    'offline'
                            }
                        ></span>{" "}
                        {agentStatusListInfo[row.email] ? agentStatusListInfo[row.email] : 'Offline'}
                    </div>
                ),
            },
            {
                name: "Add Participant",
                cell: (row: any) => (
                    <Button
                        size="sm"
                        disabled={
                            agentStatusListInfo[row.email] &&
                                agentStatusListInfo[row.email].toLowerCase() === "online" &&
                                LoginUserDetails.email !== row.email ? false
                                : true
                        }
                        className="ml-1"
                        onClick={() => {
                            addAgentModelCallBackFunction(row);
                        }}
                        variant="success"
                    >
                        <i className="bi bi-person-plus-fill"></i>
                    </Button>
                ),
            },
        ];
        columns = addAgentColumn;
    }
    const getLocationsAsCSV = (data: any) => {
        return data
            .map((item: any) => {
                return item.name;
            })
            .join(", ");
    };

    return (
        <>
            {showLoader ? (
                <AppLoader />
            ) : (
                <Container fluid>
                    <TopHeader
                        heading="Team"
                        to="dashboard"
                    // action="Dashboard"
                    // className="bi bi-speedometer"
                    />
                    <TableComponent filteredItems={data} columns={columns} />
                </Container>
            )}
        </>
    );
});

export default Teams;
